var React = require('react');

function Slack (props) {
    return React.createElement("svg",props,[React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0..75","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"15.3","y1":"3.9","x2":"2","y2":"8.6","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0..75","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"17.4","y1":"10.4","x2":"4","y2":"15.1","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0..75","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.2","y1":"4.3","x2":"7.9","y2":"17.5","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0..75","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"11.4","y1":"1.5","x2":"16.1","y2":"14.7","key":3})]);
}

Slack.displayName = "Slack";

Slack.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 19 19","style":{"enableBackground":"new 0 0 19 19"},"xmlSpace":"preserve"};

module.exports = Slack;

Slack.default = Slack;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/slack.svg
// module id = ../icon/src/icons/slack.svg
// module chunks = 0